import { getSupportArticleUrl } from '@/services/supportUrlService';
angular.module("leanlaw").controller("UpgradeToProExpenseAttachmentsModals", ["$scope", "close", "$state", "tracking", function ($scope, close, $state, tracking) {
  onActivated();
  function onActivated() {
    tracking.event("Clicked", "Upgrade to pro modals opened", {
      UpgradeToProModalsOpened: true
    });
  }
  $scope.upgradeNow = function () {
    tracking.event("Clicked", "Go To Subscription", {
      GoToSubscription: true
    });
    close(true);
  };
  $scope.openSupportLink = function () {
    window.open(getSupportArticleUrl('expenseAttachments'), "_blank");
  };
  $scope.handleCloseButton = function () {
    close(false);
  };
}]);